// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__130W3","row":"ProcedureTreatmentSummary_row__1DOQ_"};